//@ts-ignore
import ProgressBarContainer from "ProgressBar/ProgressBarContainer.vue";
import Vue from 'vue-ltur';
var initializeProgressBar = function () {
    var progressBarContainer = document.getElementById('progressBar');
    if (progressBarContainer !== null) {
        new Vue({
            render: function (h) { return h(ProgressBarContainer); },
        }).$mount('#progressBar');
    }
};
export default initializeProgressBar;
